export default __webpack_public_path__ + "static/media/marker.a8098185.png";